import React, { useCallback, useEffect, useRef, useState } from "react";
import styles from "styles/component/CourseMapOptionListTable.module.scss";
import styles1 from "styles/component/PopOver.module.scss";
import popoverStyles from "styles/component/CustomPopover.module.scss";
import * as _ from "underscore";
import {
  Box,
  Button,
  FormControl,
  FormControlLabel,
  FormLabel,
  MenuItem,
  Radio,
  RadioGroup,
  Select,
  Stack,
} from "@mui/material";
import asset from "json/assets";
import {
  buildPayloadFromHoleData,
  checkAndUnionArrays,
  convertObjectToArray,
  convertSingleLatLngStringtoFloatArray,
  convertToLabelName,
  decryptSecretKey,
  getModalProperties,
  getNumberFromLabel,
  getSelectedIds,
} from "services/utils";
import { useDispatch } from "react-redux";

import {
  HoleElements,
  HoleFeatures,
  courseMapElementLimit,
  courseMapZoneTypeList,
} from "json/constants";
// import eventEmitter from "services/event.emitter";
// import events from "json/events";
import ModalWrapper from "layout/ModalWrapper/ModalWrapper";
import NoificationModal from "pages/ModalPage/NoificationModal";
import { useRefHook } from "hooks/useRefHook";
import {
  useCourseGPSMappingData,
  useCourseGPSNameList,
  useCourseHoleData,
  useCourseHoleNumber,
  useCourseMapData,
  useCoursePolygonPropertiesDesc,
  useCoursePolygonPropertiesType,
  useEditableCourseItem,
  useIsDrawingStatus,
  useVisibleCourseElements,
} from "hooks/CourseMapDetails";
import {
  clearCourseShapePropertiesDesc,
  clearCourseShapePropertiesSize,
  clearCourseShapePropertiesType,
  clearEditableCourseItem,
  course_gps_vector_map_update,
  course_map_gps_vector_details,
  setEditableCourseItem,
  setEditedMarkerPointToBlink,
  setMarkerLocations,
  setSelectedCourseZoneType,
  setSelectedHoleNumber,
  setVisibleCourseElements,
  updateCourseMapData,
  updateCourseMappingData,
  course_gps_vector_map_remove
} from "redux/CourseMapSlice";
import eventEmitter from "services/event.emitter";
import events from "json/events";
import useNotiStack from "hooks/useNotistack";
import { useProfileUsername } from "hooks/ProfileDetails";
import { useSearchParams } from "react-router-dom";
import { isHoleVectorElement, isVectorElement, HOLE_VECTOR_ELEMENTS } from "./CourseMapOtionListTable.helper";
import BackdropLoader from "ui/BackdropLoader/BackdropLoader";

export default function CourseMapOptionListTable(props) {
  const dispatch = useDispatch();
  const {
    contentData,
    // cancelEdit = () => {},
    hazardData = [],
    fcbData = [],
    teeCenterData = [],
    element,
    setElement
  } = props;
  const { toastError } = useNotiStack();

  const [openDeleteModal, setOpenDeleteModal] = useState(false)
  const [remapHoleLoading, setRemapHoleLoading] = useState(false);
  const CourseGPSNameListResponse = useCourseGPSNameList();

  const visibleCourseElements = useVisibleCourseElements();
  const courseMapData = useCourseMapData();
  const courseGPSMapping = useCourseGPSMappingData();
  const courseGPSMappingData = courseGPSMapping?.GPSList;
  const modalProperties = getModalProperties();
  const editableArea = useEditableCourseItem();
  const isDrawingStatus = useIsDrawingStatus();
  const holWiseData = useCourseHoleData()
  const editableAreaRef = useRefHook(editableArea);

   const bunkerPolygonType = useCoursePolygonPropertiesType()
    const bunkerPolygonDesc = useCoursePolygonPropertiesDesc()
  // default holeCount
  const [defaultHoleCount, setDefaultHoleCount] = useState(
    courseMapData?.LayoutHoles
  );
  const defaultHoles = Array.from(
    { length: defaultHoleCount },
    (_, index) => index
  );
  //default selected zone

  const [openConfModal, setOpenConfModal] = useState(false);
  const [openDelAllConfModal, setOpenDelAllConfModal] = useState(false);

const [selectedHole, setSelectedHole] = useState(() =>
  Number(sessionStorage.getItem("prevSetHole") ?? 0)
);  // !_.isEmpty(contentData) ? Object.keys(contentData)[0] : 1

  const ScrollableClient = useRef();

  const [prevSelectedHole, setPrevSelectedHole] = useState();
  const [showableData, setShowableData] = useState([]);
  const [showableFCBData, setShowableFCBData] = useState([]);
  const [selectedShape, setSelectedShape] = useState(null);
  const [propertiesChange, setPropertiesChange] = useState()
  const [markerOpacity, setMarkerOpacity] = useState(1);
  const [searchParams] = useSearchParams();

  const secret_Key = decryptSecretKey();
  const username = useProfileUsername();
  const id_courseFromQuery = searchParams.get("course");

  const handleAllDelClose = () => {
    setOpenDelAllConfModal(false);
  };
  const handleClose = () => {
    setOpenConfModal(false);
  };

  const handleHoleClose = ()=> {
    setOpenDeleteModal(false)
  }

  const getPreviousSelectedHole = sessionStorage.getItem("prevSetHole")

  useEffect(() => {
    if (getPreviousSelectedHole) {
      const v = Number(getPreviousSelectedHole);
      setSelectedHole(v);
      eventEmitter.emit(events.fitMapToHole, { holeNumber: v + 1, force: true });
    }
  }, [getPreviousSelectedHole]);

  useEffect(() => {
    const holeNo = selectedHole + 1;
    dispatch(setSelectedHoleNumber(holeNo));
    eventEmitter.emit(events.fitMapToHole, { holeNumber: holeNo, force: true });
  }, [selectedHole, dispatch]);

  
  
  const handleChange = (event) => {
    eventEmitter.emit(events.resetDrawingMode);

    const value = Number(event.target.value); // ensure number
    setSelectedHole(value);
    sessionStorage.setItem("prevSetHole", String(value));

    // zoom immediately on hole change
    eventEmitter.emit(events.fitMapToHole, { holeNumber: value + 1, force: true });
    setPrevSelectedHole(value);
};

  // const zoomIntoSelectedHole = () => {    
  //   if (selectedHole !== null && selectedHole !== undefined) {
  //     const holeNumber = selectedHole + 1;
  //     eventEmitter.emit(events.fitMapToHole, { holeNumber });
  //     setPrevSelectedHole(selectedHole);
  //   }
  // };

  
  const fillData = () => {

    let MapData = convertObjectToArray(contentData[`${selectedHole}`])[0];
    let showableData = [];


if(element !== "Hazard" && element !== "fcb"  && element !== "Teeboxcenter"  )
{
    if(!_.isEmpty(contentData))
    {
           //default
        showableData = MapData ? MapData[element]?.Shapes?.Shape : [];
        showableData?.length
          ? setShowableData(showableData)
          : setShowableData([]);
    }
}
else{
  if (element === "Hazard") {
    showableData = hazardData[selectedHole];
    setShowableData(hazardData[selectedHole]);
  } else if (element === "fcb") {
    showableData = fcbData[selectedHole];
    setShowableFCBData(fcbData[selectedHole]);
  } else if (element === "Teeboxcenter") {
    showableData = teeCenterData[selectedHole];
    setShowableData(teeCenterData[selectedHole]);
}
}
    selectCourseZoneType(showableData);
  };
  const selectCourseZoneType = (showableData) => {
    // const holeNo  = selectedHole + 1
    // dispatch(setSelectedHoleNumber(holeNo))
    dispatch(
      setSelectedCourseZoneType({
        hole: parseInt(selectedHole) + 1,
        type: courseMapZoneTypeList[`${element.toLowerCase()}`],
        element: element,
        // data:showableData?.length?showableData:(showableFCBData?.length? showableFCBData:[])
        data: showableData,
      })
    );
  };
  useEffect(() => {
    fillData();
    return () => {
      setShowableData([]);
      setShowableFCBData([]);
    };
  }, [selectedHole, contentData, fcbData, element]);

  let ListTableHeader = {
    eye: `${asset.eye}`,
    close: `${asset.close}`,
  };

  const getActiveViewIcon = (data) => {
    if (data?.id) {
      return visibleCourseElements[selectedHole][element]?.idList?.includes(
        data?.id
      );
    } else {
      return false;
    }
  };
  const toggleActivePolygonView = (data) => {

    if(editableArea?.type === "Teeboxcenter" || editableArea?.type === "fcb" ||  editableArea?.type === "hazard"){
      toastError(`Cannot hide/show ${editableArea?.type} while edit is active`)
    }else{
      let temp_visibleCourseElements = JSON.parse(
        JSON.stringify(visibleCourseElements)
      );
      let pos = temp_visibleCourseElements[parseInt(selectedHole)][
        element
      ]?.idList?.findIndex((s) => s === data?.id);
      if (
        temp_visibleCourseElements[parseInt(selectedHole)][element]?.idList[pos]
      ) {
        temp_visibleCourseElements[parseInt(selectedHole)][
          element
        ]?.idList.splice(pos, 1);
      } else {
        temp_visibleCourseElements[selectedHole][element]?.idList?.push(data?.id);
      }
      dispatch(setVisibleCourseElements(temp_visibleCourseElements));
    }
  };

  const toggleAllActivePolygonView = () => {
    if(editableArea?.type === "Teeboxcenter" || editableArea?.type === "fcb" ||  editableArea?.type === "hazard"){
      toastError(`Cannot hide/show ${editableArea?.type} while edit is active`)
    }else{
      let temp_visibleCourseElements = JSON.parse(
        JSON.stringify(visibleCourseElements)
      );
      if (temp_visibleCourseElements[parseInt(selectedHole)][element]) {
        temp_visibleCourseElements[parseInt(selectedHole)][
          element
        ].isElementVisible =
          !temp_visibleCourseElements[parseInt(selectedHole)][element]
            .isElementVisible;
      }
      dispatch(setVisibleCourseElements(temp_visibleCourseElements));
    }
  };

  const clearEditableModeVariables = () => {
    dispatch(clearEditableCourseItem());
    dispatch(clearCourseShapePropertiesType());
    dispatch(clearCourseShapePropertiesSize());
    dispatch(clearCourseShapePropertiesDesc());
  };
const isShapeHoleItem = (shape) => {
  
  return shape && shape.zone
    ? HoleElements.some((s) => s.toLowerCase() === shape?.zone.toLowerCase())
    : false;
};

const removeVectorsBulk = async ({ element, holeNumber }) => {
  if (!isHoleVectorElement(element)) return;

  await dispatch(
    course_gps_vector_map_remove({
      body: {
        id_courseInt: Number(id_courseFromQuery),
        name: element,                // same as UI
        ...(holeNumber ? { holeNumber } : {}),
      },
      user: { secretKey: secret_Key, userName: username },
    })
  );

  await dispatch(
    course_map_gps_vector_details({
      body: { id_course: id_courseFromQuery },
      user: { secretKey: secret_Key, userName: username },
    })
  );
};


 const updateCourseGPSVectorMap = (payload) => {
    dispatch(
      course_gps_vector_map_update({
        body: payload,
        user: {
          secretKey: secret_Key,
          userName: username,
        },
      })
    ).then((res)=> {
      if (res?.payload?.data?.Status === 1) {
        dispatch(
          course_map_gps_vector_details({
            body: {
              id_course: id_courseFromQuery,
            },
            user: {
              secretKey: secret_Key,
              userName: username,
            },
          })
        )
      } else {
        toastError(`CourseGPSVectorMapUpdate failed (id_course: ${id_courseFromQuery}). Server response: ${JSON.stringify(res?.payload?.data)}`);
      }
    })
  };
useEffect(() => {
const pointsArray = propertiesChange?.list[0].map(([lat, lng]) => ({ lat, lng }));
if(pointsArray && bunkerPolygonType !== null){
   if(bunkerPolygonType !== propertiesChange?.Attributes?.Type || 
    bunkerPolygonDesc !==  propertiesChange?.Attributes?.Description ){
    let payload = {
           
      holeNumber: propertiesChange?.hole,
      id_courseGPSVector: propertiesChange?._id,
      name: propertiesChange?.label,
      points: pointsArray,
      type: 3,
      typeAttribute: bunkerPolygonType,
      descriptionAttribute: bunkerPolygonDesc,

    };
updateCourseGPSVectorMap(payload);
   }

  }
}, [bunkerPolygonType, bunkerPolygonDesc ])

const toggleEditMode = (shape) => {

  if (isDrawingStatus) return;

  if (shape?.hole === -1) {
    if (_.isEmpty(editableAreaRef.current)) {
      dispatch(setEditableCourseItem(shape));
    }
    return;
  }

  if (_.isEmpty(editableAreaRef.current)) {
    let isHoleItem = isShapeHoleItem(shape);

    if (isHoleItem) {
      switch (shape?.zone) {
        case "Greencenter":
          if (editableArea?.greenID === shape?.greenID) {
            clearEditableModeVariables();
          } else {
            dispatch(setEditableCourseItem(shape));
          }
          break;
        default:
          if (editableArea?._id === shape?._id) {
            // dispatch(clearEditableCourseItem());
            clearEditableModeVariables();
          } else {
            setPropertiesChange(shape)
            dispatch(setEditableCourseItem(shape));
          }
          break;
      }
    } else {
      dispatch(setEditableCourseItem(shape));
    }
  }

};
  const getDeleteConfirmation = (data) => {
    setOpenConfModal(true);
  };

  const getDeleteAllConfirmation = (data) => {
    if (checkIfActionable()) {
      setOpenDelAllConfModal(true);
    } else {
      toastError("can not delete elements while draw/edit is active");
    }
  };
  // const clearSelectedElements = useCallback(
  //   (data) => {
  //     // return;
  //     // let temp_shapeData = { ...shapeData };
  //     // let currentZone = [...temp_shapeData[`${selectedHole}`]];
  //     // let pos = temp_shapeData[`${selectedHole}`]?.findIndex(
  //     //   (s) => s.label === data?.label
  //     // );
  //     // currentZone?.splice(pos, 1);
  //     // temp_shapeData[`${selectedHole}`] = currentZone;
  //     // let reduxData = { shapes: temp_shapeData };
  //     // let temp = [...visibleAreasList];
  //     // if (visibleAreasList?.includes(data?.label)) {
  //     //   // toggle off
  //     //   let index = temp.indexOf(data?.label);
  //     //   temp.splice(index, 1);
  //     //   dispatch(setVisibleArea(temp));
  //     // }
  //     // dispatch(setMapData(reduxData));
  //   },
  //   [selectedHole]
  // );

  const clearAllElements = async () => {
    if (element === "fcb") {      
      let temp_courseGPSMappingData = structuredClone(courseGPSMappingData);
      let selecteData = temp_courseGPSMappingData[selectedHole];
      selecteData.frontLat = 0;
      selecteData.frontLon = 0;
      selecteData.centerLat = 0;
      selecteData.centerLon = 0;
      selecteData.backLat = 0;
      selecteData.backLon = 0;

      // delete selecteData.frontLat;
      // delete selecteData.frontLon;
      // delete selecteData.centerLat;
      // delete selecteData.centerLon;
      // delete selecteData.backLat;
      // delete selecteData.backLon;
      temp_courseGPSMappingData[selectedHole] = selecteData;
      dispatch(updateCourseMappingData(temp_courseGPSMappingData));
      eventEmitter.emit(
        events.deleteCourseMapElement.courseMapSimpleDataDelete,
        { data: temp_courseGPSMappingData }
      );
    } else if (element === "Hazard") {
      let temp_courseGPSMappingData = structuredClone(courseGPSMappingData);
      let selecteData = temp_courseGPSMappingData[selectedHole];
      for (let i = 1; i <= courseMapElementLimit.hazard; i++) {
        // delete selecteData[`customLat${i}`];
        // delete selecteData[`customLon${i}`];
        // delete selecteData[`customDesc${i}`];
        // delete selecteData[`customName${i}`];
        let GPSNameObject = CourseGPSNameListResponse.find((s) => s.id === 0);
        selecteData[`id_courseGPSName${i}`] = GPSNameObject.id;
        selecteData[`customLat${i}`] = GPSNameObject.name;
        selecteData[`customName${i}`] = GPSNameObject.name;
        selecteData[`customDesc${i}`] = GPSNameObject.description;
        selecteData[`customLat${i}`] = 0;
        selecteData[`customLon${i}`] = 0;
      }
      temp_courseGPSMappingData[selectedHole] = selecteData;
      dispatch(updateCourseMappingData(temp_courseGPSMappingData));
      eventEmitter.emit(
        events.deleteCourseMapElement.courseMapSimpleDataDelete,
        { data: temp_courseGPSMappingData }
      );
      //
    } else if (element === "Teeboxcenter") {
      let temp_courseGPSMappingData = structuredClone(courseGPSMappingData);
      let selecteData = temp_courseGPSMappingData[selectedHole];
      for (let i = 1; i <= courseMapElementLimit.teeboxcenter; i++) {
        // delete selecteData[`teeLat${i}`];
        // delete selecteData[`teeLon${i}`];
        selecteData[`teeLat${i}`] = 0;
        selecteData[`teeLon${i}`] = 0;
      }
      temp_courseGPSMappingData[selectedHole] = selecteData;
      dispatch(updateCourseMappingData(temp_courseGPSMappingData));
      eventEmitter.emit(
        events.deleteCourseMapElement.courseMapSimpleDataDelete,
        { data: temp_courseGPSMappingData }
      );
    } else if(isVectorElement(element)) {
      //default
      const holeNumber = Number(selectedHole) + 1;

      try {
        await removeVectorsBulk({ element, holeNumber });

        // Optimistic local cleanup for courseMapData (optional but keeps UI snappy)
        const temp_courseMapData = structuredClone(courseMapData);
        const temp_Holes = temp_courseMapData?.Holes?.Hole || [];
        if (temp_Holes[selectedHole]?.[element]) {
          delete temp_Holes[selectedHole][element];
          // element-specific companion cleanup
          if (element === "Teebox") {
            delete temp_Holes[selectedHole].Teeboxcenter;
          }
          temp_courseMapData.Holes.Hole = temp_Holes;
          dispatch(updateCourseMapData(temp_courseMapData));
        }

        // Keep your event for other subscribers
        eventEmitter.emit(
          events.deleteCourseMapElement.courseMapVectorDelete,
          { idList: [], type: "hole" } // idList not needed with bulk
        );
      } catch (e) {
        toastError("Failed to delete all elements. Please try again.");
      }
    } else {
      let temp_courseMapData = structuredClone(courseMapData);
      let temp_Holes = temp_courseMapData?.Holes.Hole;
      let idList = temp_Holes[selectedHole][`${element}`]?.Shapes?.Shape?.map(
        (s) => s.id
      ) || [];

      eventEmitter.emit(events.deleteCourseMapElement.courseMapVectorDelete, {
        idList,
        type: "hole",
      });
      delete temp_Holes[selectedHole][`${element}`];
      if (element === "Teebox") delete temp_Holes[selectedHole].Teeboxcenter;

      temp_courseMapData.Holes.Hole = temp_Holes;
      dispatch(updateCourseMapData(temp_courseMapData));
    }
  };
  const confirmationAction = () => {
    // eventEmitter.emit('ss',{id:selectedShape.id,selectedHole:parseInt(selectedHole),element:element})
    // handleClose();
    if (selectedShape) {
      if (element === "fcb") {
        let temp_fcbData = structuredClone(courseGPSMappingData);
        let temp_HoleData = temp_fcbData[parseInt(selectedHole)];
        let type = selectedShape?.place;
        // delete temp_HoleData[`${type}Lat`];
        // delete temp_HoleData[`${type}Lon`];
        temp_HoleData[`${type}Lat`] = 0;
        temp_HoleData[`${type}Lon`] = 0;
        temp_fcbData[parseInt(selectedHole)] = temp_HoleData;

        dispatch(updateCourseMappingData(temp_fcbData));
        eventEmitter.emit(
          events.deleteCourseMapElement.courseMapSimpleDataDelete,
          { data: temp_fcbData }
        );
      } else if (element === "Hazard") {
        let temp_hazardData = structuredClone(courseGPSMappingData);
        let temp_HoleData = temp_hazardData[parseInt(selectedHole)];

        let hazardSerialNumber = selectedShape.id?.split("_")[1];
        // delete temp_HoleData[`${key}`]; //deleting from main data which does not have holeNumber and id
        let GPSNameObject = CourseGPSNameListResponse.find((s) => s.id === 0);
        temp_HoleData[`id_courseGPSName${hazardSerialNumber}`] =
          GPSNameObject.id;
        temp_HoleData[`customName${hazardSerialNumber}`] = GPSNameObject.name;
        temp_HoleData[`customDesc${hazardSerialNumber}`] =
          GPSNameObject.description;
        temp_HoleData[`customLat${hazardSerialNumber}`] = 0;
        temp_HoleData[`customLon${hazardSerialNumber}`] = 0;
        // _.forEach(selectedShape, (item, key) => {
        //   if (key !== "holeNumber" && key !== "id") {
        //     let hazardSerialNumber=selectedShape.id?.split("_")[1]
        //     delete temp_HoleData[`${key}`]; //deleting from main data which does not have holeNumber and id

        //   }
        // });
        temp_hazardData[parseInt(selectedHole)] = temp_HoleData;
        dispatch(updateCourseMappingData(temp_hazardData));
        eventEmitter.emit(
          events.deleteCourseMapElement.courseMapSimpleDataDelete,
          { data: temp_hazardData }
        );
      } else if (element === "Teeboxcenter") {
        let temp_teeboxData = structuredClone(courseGPSMappingData);

        let temp_HoleData = temp_teeboxData[parseInt(selectedHole)];
        _.forEach(selectedShape, (item, key) => {
          if (key !== "holeNumber" && key !== "id" && key !== "type") {
            temp_HoleData[`${key}`] = 0;
            // delete temp_HoleData[`${key}`]; //deleting from main data which does not have holeNumber and id
          }
        });
        temp_teeboxData[parseInt(selectedHole)] = temp_HoleData;
        dispatch(updateCourseMappingData(temp_teeboxData));
        eventEmitter.emit(
          events.deleteCourseMapElement.courseMapSimpleDataDelete,
          { data: temp_teeboxData }
        );
      }
      // //default
      else {
        let temp_courseMapData = structuredClone(courseMapData);
        let temp_Holes = temp_courseMapData?.Holes.Hole;
        let pos = temp_Holes[selectedHole][element].Shapes.Shape.findIndex(
          (s) => s.id === selectedShape.id
        );
        eventEmitter.emit(events.deleteCourseMapElement.courseMapVectorDelete, {
          idList: [selectedShape.id],
          type: "hole",
        });
        temp_Holes[selectedHole][element].Shapes.Shape.splice(pos, 1);
        temp_Holes[selectedHole][element].ShapeCount =
          temp_Holes[selectedHole][element].ShapeCount - 1;

        temp_courseMapData.Holes.Hole = temp_Holes;

        dispatch(updateCourseMapData(temp_courseMapData));
      }

      handleClose();
    }
  };
  const confirmationDelAllAction = () => {
    clearAllElements();
    handleAllDelClose();
  };

const handleConfirmDeleteAllHoleData = async()=> {
    setRemapHoleLoading(true);
    let temp_courseGPSMappingData = structuredClone(courseGPSMappingData);
    let selectedData = temp_courseGPSMappingData[selectedHole];

    // fcb
      selectedData.frontLat = 0;
      selectedData.frontLon = 0;
      selectedData.centerLat = 0;
      selectedData.centerLon = 0;
      selectedData.backLat = 0;
      selectedData.backLon = 0;
      
  
    // Hazard
      for (let i = 1; i <= courseMapElementLimit.hazard; i++) {
        const GPSNameObject = CourseGPSNameListResponse.find((s) => s.id === 0);
        selectedData[`id_courseGPSName${i}`] = GPSNameObject?.id || 0;
        selectedData[`customLat${i}`] = 0;
        selectedData[`customLon${i}`] = 0;
        selectedData[`customName${i}`] = GPSNameObject?.name || '';
        selectedData[`customDesc${i}`] = GPSNameObject?.description || '';
      }
  
    // Teeboxcenter
      for (let i = 1; i <= courseMapElementLimit.teeboxcenter; i++) {
        selectedData[`teeLat${i}`] = 0;
        selectedData[`teeLon${i}`] = 0;
      }
    
  
      temp_courseGPSMappingData[selectedHole] = selectedData;
      dispatch(updateCourseMappingData(temp_courseGPSMappingData));
      eventEmitter.emit(
        events.deleteCourseMapElement.courseMapSimpleDataDelete,
        { data: temp_courseGPSMappingData }
      );

  const holeNumber = Number(selectedHole) + 1;
  
  try {
    for (const element of HOLE_VECTOR_ELEMENTS) {
      await dispatch(
        course_gps_vector_map_remove({
          body: {
            id_courseInt: Number(id_courseFromQuery),
            name: element,    
            holeNumber,        
          },
          user: { secretKey: secret_Key, userName: username },
        })
      );
    }

    // Refresh vector map data
    await dispatch(
      course_map_gps_vector_details({
        body: { id_course: id_courseFromQuery },
        user: { secretKey: secret_Key, userName: username },
      })
    );
  } catch (err) {
    toastError("Failed to delete some vector elements for this hole");
  } finally {
    setRemapHoleLoading(false);
  }

    // --- Local optimistic cleanup ---
    let temp_courseMapData = structuredClone(courseMapData);
    const holeRef = temp_courseMapData?.Holes?.Hole?.[selectedHole];
    if (holeRef) {
      HOLE_VECTOR_ELEMENTS.forEach((el) => {
        if (holeRef[el]) delete holeRef[el];
        if (el === "Teebox") delete holeRef.Teeboxcenter;
      });
      dispatch(updateCourseMapData(temp_courseMapData));
    }

    setOpenDeleteModal(false);
  }

  const handleChangeMarkerType = useCallback((event) => {
    eventEmitter.emit(events.resetDrawingMode);
    setElement(event.target.value);
  }, []);

  const hasElementData = (element) => {

    if (visibleCourseElements?.length === 0) {
      return false;
    } else {
      return visibleCourseElements[selectedHole] &&
        !_.isEmpty(visibleCourseElements[selectedHole][element?.value]?.idList)
        ? true
        : false;
    }

  };

const haveData = visibleCourseElements[selectedHole]
const hasValidData = (data) => {
  if(data){
  return Object.values(data)?.some(item =>
    Array.isArray(item.idList) &&
    item.idList.some(id => id !== null && id !== undefined)
  );
  }
};

  const isAllMemberVisible = (el) => {
    if (visibleCourseElements?.length === 0) {
      return false;
    } else {
      return visibleCourseElements[selectedHole] &&
      visibleCourseElements[selectedHole][el]?.isElementVisible
        ? true
        : false;
    }
  };

  const deleteSingleElement = (data) => {
    if (checkIfActionable()) {
      setSelectedShape(data);
      getDeleteConfirmation();
    } else {
      toastError("can not delete elements while draw/edit is active");
    }
  };


  const getElementFlyToZone = (data)=> {
    
    let flytoZone = convertSingleLatLngStringtoFloatArray(
    data?.Points,
      " "
    );
    eventEmitter.emit(events.zoomMapToCoordinate,{ coordinate: [ flytoZone[1], flytoZone[0]] });
    // eventEmitter.emit(events.triggerEditModeExternal,{shape_id:data?.id});

    
  }
  const ListTableStructure = (data, index, element) => {
    if (element === "Hazard") {
      let name =
        data?.customName1 ||
        data?.customName2 ||
        data?.customName3 ||
        data?.customName4 ||
        `Hazard${index + 1}`;
      return (
        <tr key={index} id={data?.id}>
          <td
            className={hasSingleData() ? `${styles.single_list_item}` : ""}
            // style={{
            //   cursor: "pointer",
            //   // outline: editableArea === data?.id ? "1px dashed #133E84" : "",
            // }}
            onClick={() => {
              handleBlinkMarker()
              const extractedNumber = data.id.split('_')[1]
              const customLatKey = `customLat${extractedNumber}`;
              const customLonKey = `customLon${extractedNumber}`;

              const customLat = data[customLatKey];
              const customLon = data[customLonKey];
              dispatch(setMarkerLocations([customLat, customLon]))
              eventEmitter.emit(events.zoomMapToCoordinate,{ coordinate: [ customLat, customLon] });
              // toggleEditMode(data);

            }}
           
            onDoubleClick={() => {
              // visibleAreasList?.includes(data?.label) &&
              // toggleEditMode(data);
            }}

            // className={noProp===true?`${styles.defaultzone_save_btn}` :""}
          >
            <Stack
              direction={"row"}
              alignItems={"center"}
              flexWrap={"wrap"}
              justifyContent={"space-between"}
            >
              {name}
            </Stack>
          </td>

          <td>
            <Box className={styles.color_mod_box}>
              <Button
                id={index}
                className={
                  // styles.green
                  isAllMemberVisible(element) && getActiveViewIcon(data)
                    ? //  && !editableArea
                      `${styles.green}`
                    : `${styles.grey}`
                }
                // disabled={editableArea}
                onClick={() => {
                  isAllMemberVisible(element) && toggleActivePolygonView(data);
                }}
              >
                <img src={asset.eye} alt="" className="eye_size" />
              </Button>
            </Box>
          </td>
          <td>
            <Box className={styles.color_mod_box}>
              <Button
                // disabled={editableArea}
                onClick={() => {
                  deleteSingleElement(data);
                }}
              >
                <img src={asset.close} alt="" />
              </Button>
            </Box>
          </td>
        </tr>
      );
    }
    if (element === "Teeboxcenter")
      return (
        <tr key={index} id={data?.id}>
          <td
            // style={{
            //   cursor: "pointer",
            //   // outline: editableArea === data?.id ? "1px dashed #133E84" : "",
            // }}
            className={hasSingleData() ? `${styles.single_list_item}` : ""}
            onClick={() => {
              handleBlinkMarker()
              dispatch(setMarkerLocations([ data?.teeLat1 || data?.teeLat2 || data?.teeLat3 || data?.teeLat4 || data?.teeLat5, data?.teeLon1 || data?.teeLon2 || data?.teeLon3 || data?.teeLon4 || data?.teeLon5]))
              eventEmitter.emit(events.zoomMapToCoordinate,{ coordinate: [ data?.teeLat1 || data?.teeLat2 || data?.teeLat3 || data?.teeLat4 || data?.teeLat5, data?.teeLon1 || data?.teeLon2 || data?.teeLon3 || data?.teeLon4 || data?.teeLon5] });
              toggleEditMode(data)
            }}

            onDoubleClick={() => {
              // eventEmitter.emit(events.zoomMapToCoordinate,{ coordinate: [ data?.teeLat1, data?.teeLon1] });
              // getElementFlyToZone(data)
              // visibleAreasList?.includes(data?.label) &&
              // toggleEditMode(data);
            }}

            // className={noProp===true?`${styles.defaultzone_save_btn}` :""}
          >
            <Stack
              direction={"row"}
              alignItems={"center"}
              flexWrap={"wrap"}
              justifyContent={"space-between"}
            >
              {"Teeboxcenter"} {index + 1}
              {/* {data?.label} */}
              {/* {noProp === true &&
        data?.label === editableArea ? (
          <Button
            className={styles.defaultzone_save_btn}
            onClick={saveElementChanges}
          > 
            <img src={asset.editIcon} alt="Save" />
          </Button>
        ) : (
          ""
        )} */}
            </Stack>
          </td>

          <td>
            <Box className={styles.color_mod_box}>
              <Button
                id={index}
                className={
                  // styles.green
                  isAllMemberVisible(element) && getActiveViewIcon(data)
                    ? //  && !editableArea
                      `${styles.green}`
                    : `${styles.grey}`
                }
                // disabled={editableArea}
                onClick={() => {
                  isAllMemberVisible(element) && toggleActivePolygonView(data);
                }}
              >
                <img src={asset.eye} alt="" className="eye_size" />
              </Button>
            </Box>
          </td>
          <td>
            <Box className={styles.color_mod_box}>
              <Button
                // disabled={editableArea}
                onClick={() => {
                  deleteSingleElement(data);
                }}
              >
                <img src={asset.close} alt="" />
              </Button>
            </Box>
          </td>
        </tr>
      );
    else
      return (
        //single_list_item
        <tr
          key={index}
          id={data?.label}
          className={hasSingleData() ? `${styles.single_list_item}` : ""}
        >
          <td
            // style={{
            //   cursor: "pointer",
            //   outline: editableArea === data?.label ? "1px dashed #133E84" : "",
            // }}
            onClick={()=>{
              const matchedData = holWiseData.find(item => item.id === data.id || item._id === data.id)
              getElementFlyToZone(data)
              toggleEditMode(matchedData)

            }}
              
            onDoubleClick={() => {
              // getElementFlyToZone(data)
              // eventEmitter.emit(events.zoomMapToCoordinate,{ coordinate: [ data?.teeLat1, data?.teeLon1] });

              // getElementFlyToZone(data)
              // visibleAreasList?.includes(data?.label) &&
              // toggleEditMode(data);
            }}

            // className={noProp===true?`${styles.defaultzone_save_btn}` :""}
          >
            <Stack
              direction={"row"}
              alignItems={"center"}
              flexWrap={"wrap"}
              justifyContent={"space-between"}
            >
              {element === "Centralpath" ? "Central Path" : element} {index + 1}
              {/* {data?.label} */}
              {/* {noProp === true &&
                  data?.label === editableArea ? (
                    <Button
                      className={styles.defaultzone_save_btn}
                      onClick={saveElementChanges}
                    > 
                      <img src={asset.editIcon} alt="Save" />
                    </Button>
                  ) : (
                    ""
                  )} */}
            </Stack>
          </td>

          <td>
            <Box className={styles.color_mod_box}>
              <Button
                id={index}
                className={
                  // styles.green
                  isAllMemberVisible(element) && getActiveViewIcon(data)
                    ? //  && !editableArea
                      `${styles.green}`
                    : `${styles.grey}`
                }
                // disabled={editableArea}
                onClick={() => {
                  isAllMemberVisible(element) && toggleActivePolygonView(data);
                }}
              >
                <img src={asset.eye} alt="" className="eye_size" />
              </Button>
            </Box>
          </td>
          <td>
            <Box className={styles.color_mod_box}>
              <Button
                // disabled={editableArea}
                onClick={() => {
                  deleteSingleElement(data);
                  // setSelectedShape(data);
                  // getDeleteConfirmation();
                }}
              >
                <img src={asset.close} alt="" />
              </Button>
            </Box>
          </td>
        </tr>
      );
  };

  const handleBlinkMarker = () => {
    let count = 0;
    const interval = setInterval(() => {
      setMarkerOpacity((prev) => (prev === 1 ? 0.5 : 1));
      count++;
      
      // After 3 seconds (6 toggles of 500ms), stop the interval and set opacity to 1
      if (count >= 6) {
        clearInterval(interval);
        setMarkerOpacity(1); // Ensure the opacity is set to 1 at the end
       
      }
    }, 1000);
  };
  
useEffect(()=> {
  dispatch(setEditedMarkerPointToBlink(markerOpacity))
},[markerOpacity])

useEffect(() => {
  const prev = Number(sessionStorage.getItem("prevSetHole"));
  if (Number.isFinite(prev)) setSelectedHole(prev);
}, [contentData]);
  
  const FcbListTableStructure = (data, name, element) => {

    if (name !== "holeNumber")
      return (
        <tr key={name} id={data?.label}>
          <td
            // style={{
            //   cursor: "pointer",
            //   outline: editableArea === data?.label ? "1px dashed #133E84" : "",
            // }}
            onClick={()=>{
              handleBlinkMarker()
              dispatch(setMarkerLocations([data?.shape[0], data?.shape[1]]))
              eventEmitter.emit(events.zoomMapToCoordinate,{ coordinate: [ data?.shape[0], data?.shape[1]] });
              
              // toggleEditMode(data)
            }}
            onDoubleClick={() => {
              // visibleAreasList?.includes(data?.label) &&
              // toggleEditMode(data);
            }}

            // className={noProp===true?`${styles.defaultzone_save_btn}` :""}
          >
            <Stack
              direction={"row"}
              alignItems={"center"}
              flexWrap={"wrap"}
              justifyContent={"space-between"}
            >
              {convertToLabelName(data?.place)}

              {/* {convertToLabelName(name)} */}
            </Stack>
          </td>

          <td>
            <Box className={styles.color_mod_box}>
              <Button
                id={name}
                className={
                  // styles.green
                  isAllMemberVisible(element) && getActiveViewIcon(data)
                    ? //  && !editableArea
                      `${styles.green}`
                    : `${styles.grey}`
                }
                // disabled={editableArea}
                onClick={() => {
                  isAllMemberVisible(element) && toggleActivePolygonView(data);
                }}
              >
                <img src={asset.eye} alt="" className="eye_size" />
              </Button>
            </Box>
          </td>
          <td>
            <Box className={styles.color_mod_box}>
              <Button
                // disabled={editableArea}
                onClick={() => {
                  deleteSingleElement(data);
                }}
              >
                <img src={asset.close} alt="" />
              </Button>
            </Box>
          </td>
        </tr>
      );
  };

  const checkIfActionable = () => {
    if (isDrawingStatus || !_.isEmpty(editableArea)) {
      return false;
    } else return true;
  };

  const hasSingleData = () => {
    return ["perimeter", "green", "centralpath"].includes(
      element?.toLowerCase()
    );
  };
  
  return (
    <>
      <div
        className={`${
          `${styles.table_select}`
          // !singleType
          //   ? `${styles.table_select}`
          //   : `${styles.table_select}${styles.table_blank}`
        }`}
      >
        {/* {Object.keys(contentData)?.length == 1 ? (
            <></>
            // <span className={styles1.header_span}>{convertToLabelName(Object.keys(contentData)[0])}</span>
          ) : <></> 
          } */}
        {/* {!singleType ? ( */}
        <FormControl className={styles1.dropdown_select}>
          <Select
            // value={getPreviousSelectedHole ? (getPreviousSelectedHole +1) : selectedHole}
            value={selectedHole}
            // onChange={handleChange}
            onChange={(e) => {
              // if (checkIfActionable()) {
              handleChange(e);
              // }
            }}
            displayEmpty
            inputProps={{ "aria-label": "Without label" }}
            // disabled={
            //   editableArea || addedShapeStatus !== "idle" ? true : false
            // }
          >
            {defaultHoles?.map((item, index) => {
              return (
                <MenuItem value={item}>{`Hole ${parseInt(item) + 1}`}</MenuItem>
              );
            })}
            {/* {!_.isEmpty(contentData) ?
                Object.keys(contentData).map((dataItem, index) => {
                  return (
                    <MenuItem value={dataItem}>
                      {`Hole ${parseInt(dataItem) + 1}`}
                    </MenuItem>
                  );
                })
                :
               defaultHoles?.map((item,index)=>{
                  return (
                    <MenuItem value={item}>
                      {`Hole ${parseInt(item)}`}
                    </MenuItem>
                  );
                })
                
                } */}
          </Select>
        </FormControl>
        {/* )         : (
          ""
        )} */}
      </div>
      <Box className={popoverStyles.poover_content}>
        <Box
          className={`${popoverStyles.popover_body_new} ${popoverStyles.popover_body_courseMapList}`}
        >
          {/* <MultiSelect /> */}
          <FormControl>
            {/* <FormLabel id="demo-radio-buttons-group-label">SELECT TYPE</FormLabel> */}
            <RadioGroup
              className={styles.marker_option}
              aria-labelledby="demo-radio-buttons-group-label"
              // defaultValue="FLAG"
              name="radio-buttons-group"
              // value={"Hole 1"}
              value={element}
              onChange={(e) => {
                // if (checkIfActionable()) {
                handleChangeMarkerType(e);
                // }
              }}
            >
              {HoleFeatures?.map((marker, index) => (
                <>
                  <FormControlLabel
                    className={
                      hasElementData(marker)
                        ? `${popoverStyles.green_border}`
                        : ""
                    }
                    // className={popoverStyles.green_border} // for green  outline
                    value={marker.value}
                    control={<Radio checked={marker.value === element} />}
                    // control={<Radio checked={marker.value === "teeboxes"} />}
                    label={marker.label}
                    key={index}
                  />
                </>
              ))}
        {hasValidData(haveData) && <FormControlLabel
                  value=""
                  control={<Radio checked={false} />}
                  label="REMAP HOLE"
                  onClick={()=> setOpenDeleteModal(true)}
                  
                  // key={index}
                /> }
               
            </RadioGroup>
          </FormControl>
          {/* {errorMsg && errorComponent()} */}
        </Box>
      </Box>

      <div
        className={styles.table_btm}
        ref={ScrollableClient}
        id="listContainer"
      >
        {/* <table className={isTableStylesTwo  ?`${styles.table_two}`:""}> */}
        {
          // !showableData.length
          _.isEmpty(showableData) && _.isEmpty(showableFCBData) ? (
            <div className={styles1.list_icon_para}>
             
              <p className={styles.no_marker_text}>
                   {/* {element === "fcb" ?  `No Front/Center/Back Mapped` : 
                    element === "Centralpath" ? `No Central Path Mapped` : element === "Teebox" ? `No ${element}es Mapped` : 
                    element === "Teeboxcenter" ? `No ${element}s Mapped`} */}
                    {element ? ` No ${element === "fcb" ? "Front/Center/Back" :
                    element === "Centralpath" ? "Central Path": 
                    element === "Teebox" ? `${element}es` :
                    element === "Teeboxcenter" ? "Teebox Centers" :
                    element === "Perimeter" || element === "Green" ? element :
                    `${element}s`} Mapped` : ""}
                   
                    </p>
            </div>
          ) : (
            <table className={""} id={"list_table"}>
              <thead>
                {!hasSingleData() && (
                  <tr>
                    <th>
                      {`All ${convertToLabelName(element)}${(element === "Teebox" ? "es" : "s")}`}
                      {/* {convertToLabelName(selectedHole) === "Facility Marker" ||
                    convertToLabelName(selectedHole) === "Perimeter"
                      ? `All ${convertToLabelName(element)}s`
                      : element === "fcb"
                      ? "All FCB"
                      : `All ${convertToLabelName(element)}`} */}
                    </th>
                    {/* {maxModFieldCount > 0 &&
                  Array.apply(null, Array(maxModFieldCount)).map(
                    (item, index) => <th key={item}></th>
                  )} */}
                    <th>
                      <Box className={styles.color_mod_box}>
                        <Button
                          className={`${
                            isAllMemberVisible(element)
                              ? styles.green
                              : styles.grey
                          }`}
                          // disabled={editableArea}
                          onClick={toggleAllActivePolygonView}
                        >
                          <img
                            src={ListTableHeader?.eye}
                            alt=""
                            className="eye_size"
                          />
                        </Button>
                      </Box>
                    </th>
                    <th>
                      <Box className={styles.color_mod_box}>
                        <Button
                          // disabled={editableArea}
                          className={`${styles.green}`}
                          onClick={getDeleteAllConfirmation}
                        >
                          <img src={ListTableHeader?.close} alt="" />
                        </Button>
                      </Box>
                    </th>
                  </tr>
                )}
              </thead>
              <tbody>
                {element !== "fcb" &&
                  !_.isEmpty(showableData) &&
                  _.map(showableData, (value, key) => {
                    return ListTableStructure(value, key, element);
                  })}

                {element === "fcb" &&
                  !_.isEmpty(showableFCBData) &&
                  _.map(showableFCBData, (value, key) => {
                    return FcbListTableStructure(value, key, element);
                  })}

                {/* </InfiniteScroll> */}
                {/* </>
                )} */}

                {/* )} */}
              </tbody>
            </table>
          )
        }
      </div>

      <ModalWrapper
        open={openConfModal}
        onClose={handleClose}
        handleClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <NoificationModal
          label="Warning"
          backgroundColor={modalProperties.info.backgroundColor}
          image={modalProperties.warning.icon}
          title={`<span style='font-size:14px'>Are you sure you want to delete 
               <br/>${element} from  hole ${parseInt(selectedHole) + 1}?
               </span>`}
          // content="Any unsaved data will be discarded."
          rejCallBack={handleClose}
          affrCallBack={confirmationAction}
          affrBtnTxt={"Continue"}
          rejBtnTxt={"Cancel"}
        />
      </ModalWrapper>

      <ModalWrapper
        open={openDelAllConfModal}
        onClose={handleAllDelClose}
        handleClose={handleAllDelClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <NoificationModal
          label="Warning"
          backgroundColor={modalProperties.info.backgroundColor}
          image={modalProperties.warning.icon}
          title={`<span style='font-size:14px'>Are you sure you want to delete 
          <br/>all ${element}${(element === "Teebox" ? "es" : "s")} from hole ${Number(selectedHole) + 1}?</span>`}
          // title={`<span style='font-size:14px'>Are you sure you want to delete
          //      <br/>all data from ${convertToLabelName((selectedHole))}?</span>`}
          // content="Any unsaved data will be discarded."
          rejCallBack={handleAllDelClose}
          affrCallBack={confirmationDelAllAction}
          affrBtnTxt={"Continue"}
          rejBtnTxt={"Cancel"}
        />
      </ModalWrapper>

      <ModalWrapper
        open={openDeleteModal}
        onClose={handleHoleClose}
        handleClose={handleHoleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <>
        <NoificationModal
          label="Warning"
          backgroundColor={modalProperties.info.backgroundColor}
          image={modalProperties.warning.icon}
          title={`<span style='font-size:14px'>Are you sure you want to delete 
           <br/> all elements of this hole ${parseInt(selectedHole) + 1}?
            </span> `}
          rejCallBack={handleHoleClose}
          affrCallBack={handleConfirmDeleteAllHoleData}
          affrBtnTxt={"Continue"}
          rejBtnTxt={"Cancel"}
        />
        { remapHoleLoading && <BackdropLoader open /> }
        </>
      </ModalWrapper>
    </>
  );
}
